import React from "react";
import {
  Spin,
  Divider,
  Row,
  Col
} from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "../DashboardEstablecimiento/Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoTotalVentas from "./GraficoTotalVentas";
import GraficoRankingTotalVentas from "./GraficoRankingTotalVentas";
import GraficoRankingCantidadComprobante from "./GraficoRankingCantidadComprobante";
import GraficoCantidadComprobante from "./GraficoCantidadComprobante";
import GraficoTotalVentasMensual from "./GraficoTotalVentasMensual";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      anios: anioMock.values,
      meses: mesMock.values,
      filter: {
        anioInicio: global.fetchCurrentYear(true),
        mesInicio: global.fetchCurrentMonth(true),
        anioFin: global.fetchCurrentYear(),
        mesFin: global.fetchCurrentMonth()
      },
      ///CLIENTE
      graficoTotalVentasMensual: {
        series: [],
        timeLine: [],
      },
      graficoRankingTotalVentas: {
        series: [],
        clientes: [],
      },
      graficoRankingCantidadComprobante: {
        series: [],
        clientes: [],
      },
      graficoTotalVentas: {
        series: [],
        clientes: [],
      },
      graficoCantidadComprobante: {
        series: [],
        clientes: [],
      },
    };
  }

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleClearFilters = () => {
    
    this.setState({
      fechaInicioStr: global.fetchCurrentDateStr(true),
      fechaFinStr: global.fetchCurrentDateStr(),
    });
  };

  handleGenerateReport = async (filter) => {
    this.setState({
      loading: true,
    });
    const response = await comprobanteService.dashboardCliente(filter);
    if (response !== undefined) 
    this.setState({
      graficoTotalVentasMensual: {
        series: response.dataGraficoTotalVentasMensual,
        timeLine: response.dataTimeLine,
      },
      graficoRankingTotalVentas: {
        series: response.dataGraficoRankingTotalVentas,
        clientes: response.dataClienteCortoOrderTotal,
      },
      graficoRankingCantidadComprobante: {
        series: response.dataGraficoRankingCantidadComprobante,
        clientes: response.dataClienteCortoOrderCantidad,
      },
      graficoTotalVentas: {
        series: response.dataGraficoTotalVentas,
        clientes: response.dataClienteOrderTotal,
      },
      graficoCantidadComprobante: {
        series: response.dataGraficoCantidadComprobante,
        clientes: response.dataClienteOrderCantidad,
      },
      loading: false
    });
  };

  async componentDidMount() {
    await this.handleGenerateReport(this.state.filter);
    this.setState({
      loading: false,
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Dashboard de Ventas por Cliente"
          onClearFilters={this.handleClearFilters}
          onSearch={() => this.handleGenerateReport(this.state.filter)}
        />
           <Divider />
        <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
      
        <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
              <GraficoTotalVentasMensual
                  series={this.state.graficoTotalVentasMensual.series}
                  timeLine={
                    this.state.graficoTotalVentasMensual.timeLine
                  }
                />
            </Col>
        </Row>
        <Divider className="mb-20" />
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoRankingTotalVentas
                series={this.state.graficoRankingTotalVentas.series}
                clientes={this.state.graficoRankingTotalVentas.clientes}
              />
            </Col>
        </Row>
        <Divider className="mb-20" />
        <Row gutter={16}>
            <Col className="gutter-row" sm={24} md={24} lg={24}>
                <GraficoRankingCantidadComprobante
                series={this.state.graficoRankingCantidadComprobante.series}
                clientes={this.state.graficoRankingCantidadComprobante.clientes}
              />
            </Col>
        </Row>
        <Divider className="mb-20" />
        <Row gutter={50}>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
            <GraficoTotalVentas
                series={this.state.graficoTotalVentas.series}
                clientes={this.state.graficoTotalVentas.clientes}
              />
            </Col>
            <Col className="gutter-row" sm={24} md={12} lg={12}>
            <GraficoCantidadComprobante
                series={this.state.graficoCantidadComprobante.series}
                clientes={this.state.graficoCantidadComprobante.clientes}
              />
            </Col>
        </Row>
        </Spin>
      </div>
    );
  }
}
